import { useEffect, useState } from "react";
import { getDecryptedItem } from "../utils/localStorageHelper";

export const CDN_BASE = "https://cv-uae-rec.clearvoice.cleargrid.ae";

// The Cloud-CDN-Cookie is set as part of the login response (HttpOnly, so JS
// cannot read it). We treat presence of the auth token as the signal that the
// cookie was just issued. The cookie has a 1h TTL and is not auto-refreshed —
// after that, media will stop loading until the user logs in again.
const useCdnAuth = () => {
  const [cdnReady, setCdnReady] = useState(false);
  const [error] = useState(null);

  useEffect(() => {
    const sync = () => setCdnReady(Boolean(getDecryptedItem("token")));
    sync();
    window.addEventListener("storage", sync);
    return () => window.removeEventListener("storage", sync);
  }, []);

  const cdnUrl = (path) => {
    if (!cdnReady || !path) return null;
    const clean = String(path).replace(/^\/+/, "");
    return `${CDN_BASE}/${clean}`;
  };

  return { cdnReady, cdnUrl, error };
};

export default useCdnAuth;
